/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const StubContainer = styled(Box)(({theme}) => ({
  flex: 1,
  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  borderRadius: '0 8px 8px 0',
  padding: theme.spacing(4),
  position: 'relative',
  display: 'flex',
  flexDirection: 'column' as const,
  minWidth: '682px',
}));
